import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from './styles';
import LoadingImage from 'assets/svg/loading.svg';
import CustomModal from 'components/custom-modal/CustomModal';
import { ErrorMessage, Form, Formik } from 'formik';
import CustomButton from 'components/common/custom-button/custom-button';
import { handleKeyDown, initialValuesOfStaffNotes, validationSchemaOfStaffNotes } from 'components/support/utils';
import ReactDatePicker from 'react-datepicker';
import Input from 'components/input';
import moment from 'moment';
import RadioButton from 'components/radio-button/RadioButton';
import { H5, H6, P } from 'utils/resuable-css';
import { Base64 } from 'js-base64';

const StaffNotes = ({
  closeStaffNoteModal,
  isOpenStaffModal,
  staffNotes,
  loadingStaffNotes,
  addStaffNotesLoading,
  handleAddStaffNotes,
  ticketID,
}) => {
  const [startDate, setStartDate] = useState(new Date());
  const [datetime, setDateTime] = useState(moment(startDate).format('MMMM DD, YYYY hh:mm A'));
  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    setDateTime(moment(startDate).format('MMMM DD, YYYY hh:mm A'));
    return currentDate.getTime() < selectedDate.getTime();
  };

  return (
    <Styles.DraggableContainer id="alertParent">
      <div>
        <div id="alertChild">
          <Styles.TopBar>
            <Styles.Left>
              <Icon name="user" color="black" />
              <H5>Leave a note for staff, linked to this ticket</H5>
              <P className="count">{staffNotes?.count} </P>
              {loadingStaffNotes && <img src={LoadingImage} height={28} alt="loading" />}
            </Styles.Left>
          </Styles.TopBar>
        </div>
        <Styles.Content>
          {staffNotes?.staff_notes?.map((val, i) => (
            <Styles.NotificationContainer key={i}>
              <Styles.Alert>
                <H6>{Base64.decode(val.note)}</H6>
                <P>
                  {val.date_local_format_mdy}; {val.date_ago_en}
                </P>
              </Styles.Alert>
              <Icon name="ellipsis horizontal" />
            </Styles.NotificationContainer>
          ))}
        </Styles.Content>
      </div>
      <Styles.ItalicPara>
        <i>Example: "build a server for this client", or, "contact this client at 10AM"</i>
      </Styles.ItalicPara>
      <Styles.TradeContainer onClick={() => closeStaffNoteModal()}>
        <P>Leave a note for staff, linked to this ticket</P>
      </Styles.TradeContainer>
      <CustomModal
        heading={`Leave a note for staff, linked to ticket ${ticketID}`}
        open={isOpenStaffModal}
        onClose={() => closeStaffNoteModal()}
      >
        <Formik
          initialValues={initialValuesOfStaffNotes}
          validationSchema={validationSchemaOfStaffNotes}
          onSubmit={(values) => handleAddStaffNotes(values.staff_note, values.date, datetime)}
        >
          {({ values, handleChange, handleBlur, errors, touched, setFieldValue, handleSubmit }) => (
            <Form>
              <Styles.ModalContainer>
                <Styles.SelectDateTime>
                  <H5>When should this note appear in the dashboard?</H5>
                  <Styles.DateTime onClick={() => setFieldValue('date', 'now')}>
                    <RadioButton
                      id="now"
                      setCheckedValue={(value) => setFieldValue(value)}
                      checkbox={values.date}
                      onClick={() => setFieldValue('date', 'now')}
                    />
                    <H6>Now</H6>
                  </Styles.DateTime>
                  <Styles.DateTime style={{ display: 'flex' }}>
                    <RadioButton
                      id="later"
                      setCheckedValue={(value) => setFieldValue(value)}
                      checkbox={values.date}
                      onClick={() => setFieldValue('date', 'later')}
                    />
                    <div onClick={() => setFieldValue('date', 'later')}>
                      <H6>On this date:</H6>
                      <Input
                        type="text"
                        name={'datetime'}
                        value={datetime}
                        placeholder="DateTime"
                        isFormIk={false}
                        styling={{ width: '21.3em', marginTop: '-1em' }}
                      />
                      <ReactDatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        showTimeSelect
                        filterTime={filterPassedTime}
                        dateFormat="MMMM d, yyyy h:mm aa"
                        minDate={new Date()}
                        inline
                      />
                    </div>
                  </Styles.DateTime>
                </Styles.SelectDateTime>
                <ErrorMessage name={'staff_note'} render={(msg) => <span className="error_messageSty">{msg}</span>} />
                <Styles.TextArea>
                  <textarea
                    name={'staff_note'}
                    value={values['staff_note']}
                    placeholder={'please write a note here'}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors['staff_note']}
                    touched={touched['staff_note']}
                    rows="4"
                    onKeyDown={(event) => handleKeyDown(event, handleSubmit)}
                  />
                </Styles.TextArea>
                <CustomButton
                  type="submit"
                  title="submit note"
                  buttonStyles={{
                    float: 'right',
                  }}
                  isLoading={addStaffNotesLoading}
                  onClick={handleSubmit}
                />
              </Styles.ModalContainer>
            </Form>
          )}
        </Formik>
      </CustomModal>
    </Styles.DraggableContainer>
  );
};
export default StaffNotes;
